import script from "./DateTime.vue?vue&type=script&lang=ts&setup=true"
export * from "./DateTime.vue?vue&type=script&lang=ts&setup=true"

import "./DateTime.vue?vue&type=style&index=0&id=50413a6b&lang=postcss&scoped=true"

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50413a6b"]])

export default __exports__